// @ts-nocheck
import React from 'react';
import dynamic from 'next/dynamic';
import HeadNext from 'next/head';
import NextDefaultError from 'next/error';
import useServerEnv from '@magalu/rave/config/useServerEnv';
import useClientEnv from '@magalu/rave/config/useClientEnv';

import { client , useClient  } from '@magalu/rave/graphql';
import { parseHeaders, shouldRender, middlewareClientExecutor, middlewareServerExecutor } from '@magalu/rave/utils';
import { withEventsLayer } from '@magalu/rave/hocs';

import { ErrorBoundary } from '@magalu/rave/errorBoundary';

import events , { config as eventsConfig }   from '../../events';

import { Head } from '@magalu/rave/components';
import { LazyLoading } from '@magalu/rave/components';
import { ActivityDetection } from '@magalu/rave/components';

// Modules
import { Preconnect } from '@magalu/rave/components';
import { Script } from '@magalu/rave/components';
import AllIn from '@magalu/ecomm-components/rave/scripts/AllIn';
import Criteo from '@magalu/ecomm-components/rave/scripts/Criteo';
import TikTok from '@magalu/ecomm-components/rave/scripts/TikTok';
import RTBHouse from '@magalu/ecomm-components/rave/scripts/RTBHouse';
import Stewie from '@magalu/ecomm-components/rave/scripts/Stewie';
import SpotifyAdAnalytics from '@magalu/ecomm-components/rave/scripts/SpotifyAdAnalytics';
import Hotjar from '@magalu/ecomm-components/rave/scripts/Hotjar';
  /**
  * for client modules in typescript, need to use dynamic<T> as any
  * read: https://github.com/vercel/next.js/issues/4515
  */
const Loader = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/Loader'), {
  ssr: false
});
  /**
  * for client modules in typescript, need to use dynamic<T> as any
  * read: https://github.com/vercel/next.js/issues/4515
  */
const StateLoader = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/StateLoader'), {
  ssr: false
});
import EventPageViewDispatcher from '@magalu/ecomm-components/rave/EventPageViewDispatcher';
import PageLoading from '@magalu/ecomm-components/components/PageLoading';
import AdsResolver from '../../modules/AdsResolver';
  /**
  * for client modules in typescript, need to use dynamic<T> as any
  * read: https://github.com/vercel/next.js/issues/4515
  */
const ZipCodeBar = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/ZipCodeBar'), {
  ssr: false
});
  /**
  * for client modules in typescript, need to use dynamic<T> as any
  * read: https://github.com/vercel/next.js/issues/4515
  */
const ZipCodeModal = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/ZipCodeModal'), {
  ssr: false
});
  /**
  * for client modules in typescript, need to use dynamic<T> as any
  * read: https://github.com/vercel/next.js/issues/4515
  */
const Showcase = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/Showcase'), {
  ssr: false
});
import Row from '@magalu/ecomm-components/components/Row';
  /**
  * for client modules in typescript, need to use dynamic<T> as any
  * read: https://github.com/vercel/next.js/issues/4515
  */
const TradeIn = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/TradeIn'), {
  ssr: false
});
import SummaryFactsheet from '@magalu/ecomm-components/rave/SummaryFactsheet';
import ReviewSummary from '@magalu/ecomm-components/rave/ReviewSummary';
  /**
  * for client modules in typescript, need to use dynamic<T> as any
  * read: https://github.com/vercel/next.js/issues/4515
  */
const AdsShowcase = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/AdsShowcase'), {
  ssr: false
});
import MediaGallery from '@magalu/ecomm-components/rave/MediaGallery';
import SellerChatButton from '@magalu/ecomm-components/rave/SellerChatButton';
import SocialShare from '@magalu/ecomm-components/rave/SocialShare';
import FavoriteButton from '@magalu/ecomm-components/rave/FavoriteButton';
import ClosenessTag from '@magalu/ecomm-components/rave/ClosenessTag';
import Rating from '@magalu/ecomm-components/rave/Rating';
import Heading from '@magalu/ecomm-components/rave/Heading';
import AlertAttributeMessage from '@magalu/ecomm-components/rave/AlertAttributeMessage';
import AttributeSelector from '@magalu/ecomm-components/rave/AttributeSelector';
  /**
  * for client modules in typescript, need to use dynamic<T> as any
  * read: https://github.com/vercel/next.js/issues/4515
  */
const OfferTimerTag = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/OfferTimerTag'), {
  ssr: false
});
import SellAndDeliverInfo from '@magalu/ecomm-components/rave/SellAndDeliverInfo';
import SellerDetail from '@magalu/ecomm-components/rave/SellerDetail';
import ProductPrice from '@magalu/ecomm-components/rave/ProductPrice';
import ProductTags from '@magalu/ecomm-components/rave/ProductTags';
  /**
  * for client modules in typescript, need to use dynamic<T> as any
  * read: https://github.com/vercel/next.js/issues/4515
  */
const ImportTaxes = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/ImportTaxes'), {
  ssr: false
});
import CouponCode from '@magalu/ecomm-components/components/CouponCode';
  /**
  * for client modules in typescript, need to use dynamic<T> as any
  * read: https://github.com/vercel/next.js/issues/4515
  */
const CDCCardRave = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/CDCCard'), {
  ssr: false
});
import PaymentMethodCards from '@magalu/ecomm-components/rave/PaymentMethodCards';
import TabInstallments from '@magalu/ecomm-components/rave/TabInstallments';
  /**
  * for client modules in typescript, need to use dynamic<T> as any
  * read: https://github.com/vercel/next.js/issues/4515
  */
const Shipping = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/Shipping'), {
  ssr: false
});
import LetMeKnow from '@magalu/ecomm-components/rave/LetMeKnow';
import ServicesBuyButton from '@magalu/ecomm-components/rave/ServicesBuyButton';
import BuyButtons from '@magalu/ecomm-components/rave/BuyButtons';
import AlertList from '@magalu/ecomm-components/components/AlertList';
import BuyBox from '@magalu/ecomm-components/rave/BuyBox';
import Button from '@magalu/ecomm-components/rave/Button';
import TabProductDetail from '@magalu/ecomm-components/rave/TabProductDetail';
import SellerInfo from '@magalu/ecomm-components/rave/SellerInfo';
import Benefits from '@magalu/ecomm-components/rave/Benefits';
import ReportButton from '@magalu/ecomm-components/rave/ReportButton';
  /**
  * for client modules in typescript, need to use dynamic<T> as any
  * read: https://github.com/vercel/next.js/issues/4515
  */
const AdsBanner = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/AdsBanner'), {
  ssr: false
});
import EmptyReviewButton from '@magalu/ecomm-components/rave/EmptyReviewButton';
import ReviewStats from '@magalu/ecomm-components/rave/ReviewStats';
import ProductReviewMediaCarousel from '@magalu/ecomm-components/components/ProductReviewMediaCarousel';
import ReviewListing from '@magalu/ecomm-components/rave/ReviewListing';
import ReviewSeeMore from '@magalu/ecomm-components/rave/ReviewSeeMore';
import QuestionsList from '@magalu/ecomm-components/rave/QuestionsList';
import QuestionForm from '@magalu/ecomm-components/rave/QuestionForm';
  /**
  * for client modules in typescript, need to use dynamic<T> as any
  * read: https://github.com/vercel/next.js/issues/4515
  */
const QuestionConfirm = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/QuestionConfirm'), {
  ssr: false
});
  /**
  * for client modules in typescript, need to use dynamic<T> as any
  * read: https://github.com/vercel/next.js/issues/4515
  */
const QuestionFeedback = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/QuestionFeedback'), {
  ssr: false
});
  /**
  * for client modules in typescript, need to use dynamic<T> as any
  * read: https://github.com/vercel/next.js/issues/4515
  */
const Divider = dynamic<any>(() =>
  import('@magalu/ecomm-components/components/Divider'), {
  ssr: false
});
import QuestionSeeMore from '@magalu/ecomm-components/rave/QuestionSeeMore';
import Faq from '@magalu/ecomm-components/rave/Faq';
import VersionTag from '../../modules/VersionTag';
  /**
  * for client modules in typescript, need to use dynamic<T> as any
  * read: https://github.com/vercel/next.js/issues/4515
  */
const BackToTop = dynamic<any>(() =>
  import('@magalu/ecomm-components/components/BackToTop'), {
  ssr: false
});
import Skeleton from '@magalu/ecomm-components/components/Skeleton';

// Middlewares
import getAppTheme from '@magalu/ecomm-components/rave/middlewares/getAppTheme';
import getUserInfo from '@magalu/ecomm-components/rave/middlewares/getUserInfo';
import getVersions from '../../middlewares/getVersions';
import writePromoterIdCookie from '@magalu/ecomm-components/rave/middlewares/writePromoterIdCookie';
import setPromoterCartExtensions from '@magalu/ecomm-components/rave/middlewares/setPromoterCartExtensions';
import parseAdsData from '@magalu/ecomm-components/rave/middlewares/parseAdsData';
import itemAttributeMapper from '@magalu/ecomm-components/rave/middlewares/itemAttributeMapper';
import highestInstallmentPlanAsBest from '@magalu/ecomm-components/rave/middlewares/highestInstallmentPlanAsBest';
import getProductAlerts from '@magalu/ecomm-components/rave/middlewares/getProductAlerts';
import getCouponTag from '@magalu/ecomm-components/rave/middlewares/getCouponTag';

// Data Source
import PageQuery from './query.json';

// Data Source Configs
import { configs as dataSourceConfigs } from '../../datasource/config';
const { cachePolicies = {}, localTypeDefs,  linkMiddlewares = [] } = dataSourceConfigs  as any ;
import { getParsedQuery, useRouter, useCookies, withRouter, getDeviceInfo } from '@magalu/rave/router';
import { withClientData } from '@magalu/rave/hocs';


import {
    getGlobalClassName, routeInfo, getComponents, getHeadProps,
    dataSource, getPageVariables, middlewaresArgs,
    manifest, config as raveConfig, componentsList
  } from './settings';

import routes from '../../rave-routes';

const Custom404 = dynamic(() => import('../../containers/notfound').catch(() => null));
const CustomError = dynamic(() =>
  import('../../containers/internalError').catch(() => NextDefaultError)
);

const Container = (props : Record<string, any>  = {}) => {

  const { client: clientConfig } = useClientEnv();
  const route = useRouter();

  const pageProps = { ...props, route, manifest, appConfig: raveConfig, clientConfig };

  const headProps = getHeadProps(pageProps);

  const componentProps = getComponents(pageProps);
  const className = getGlobalClassName(pageProps);
  const gridStyleHtml = {__html: `#product{display: grid;grid-template-areas: 'header header header' '. content .' 'footer footer footer';grid-template-columns: 1fr 100% 1fr;grid-template-rows: 100px min(500px, auto) 100px;}`}

  const [showSkeleton, setShowSkeleton] = React.useState(true);

  // ref: https://nextjs.org/docs/messages/react-hydration-error#solution-1-using-useeffect-to-run-on-the-client-only
  const [isClient, setIsClient] = React.useState(false);
  React.useEffect(() => {
    setIsClient(true);
  }, []);

  React.useEffect(() => {
    if (
      showSkeleton &&
      isClient &&
      (!route.dataLoading || route.isReady) &&
      Boolean(Object.keys(props.data).length)
    ) {
      setShowSkeleton(false);
    }
  }, [route.dataLoading, route.isReady, isClient]);


  if (showSkeleton) {
    return (
      <>
        <HeadNext><style dangerouslySetInnerHTML={gridStyleHtml}/></HeadNext>
          <div id="" className={className}>
            <header { ...{"style":{"gridArea":"header"}} }>
            </header>
          </div>
          <div id="" className={className}>
            <section { ...{"style":{"gridArea":"content"}} }>
                <Skeleton { ...props} {...(componentProps['content-zip-code-bar-1-placeholder']?.props || {})} />
                <Skeleton { ...props} {...(componentProps['content-row-4-children-media-gallery-0-placeholder']?.props || {})} />
                <Skeleton { ...props} {...(componentProps['content-row-5-children-row-0-children-rating-1-placeholder']?.props || {})} />
                <Skeleton { ...props} {...(componentProps['content-row-5-children-heading-1-placeholder']?.props || {})} />
                <Skeleton { ...props} {...(componentProps['content-row-5-children-attribute-selector-3-placeholder']?.props || {})} />
                <Skeleton { ...props} {...(componentProps['content-row-5-children-sell-and-deliver-info-5-placeholder']?.props || {})} />
                <Skeleton { ...props} {...(componentProps['content-row-7-children-product-price-0-placeholder']?.props || {})} />
                <Skeleton { ...props} {...(componentProps['content-row-7-children-payment-method-cards-5-placeholder']?.props || {})} />
            </section>
          </div>
          <div id="" className={className}>
            <footer { ...{"style":{"gridArea":"footer"}} }>
            </footer>
          </div>
      </>
    );
  }

  return (
    <>
      <HeadNext><style dangerouslySetInnerHTML={gridStyleHtml}/></HeadNext>
      <div id="product" className={className}>
        <Head {...props} {...headProps} />
          <header { ...{"style":{"gridArea":"header"}} }>
            
            
            
            
            <Preconnect { ...props} {...(componentProps['header-preconnect-0']?.props || {})}/>
            
            
            
            
            
            
            
            <Script { ...props} {...(componentProps['header-script-1']?.props || {})}/>
            
            
            
            
            
            
            
            <AllIn { ...props} {...(componentProps['header-all-in-2']?.props || {})}/>
            
            
            
            
            
            
            
            <Criteo { ...props} {...(componentProps['header-criteo-3']?.props || {})}/>
            
            
            
            
            
            
            
            <TikTok { ...props} {...(componentProps['header-tik-tok-4']?.props || {})}/>
            
            
            
            
            
            
            
            <RTBHouse { ...props} {...(componentProps['header-rtbhouse-5']?.props || {})}/>
            
            
            
            
            
            
            
            <Stewie { ...props} {...(componentProps['header-stewie-6']?.props || {})}/>
            
            
            
            
            
            
            
            <SpotifyAdAnalytics { ...props} {...(componentProps['header-spotify-ad-analytics-7']?.props || {})}/>
            
            
            
            
            
            
            
            <Hotjar { ...props} {...(componentProps['header-hotjar-8']?.props || {})}/>
            
            
            
            
            <ActivityDetection {...componentProps['header-loader-9'].csr.props}>
            
            
             
            <Loader { ...props} {...(componentProps['header-loader-9']?.props || {})}>
            
            
            
            
            <PageLoading { ...props} {...(componentProps['header-loader-9-children-page-loading-0']?.props || {})}/>
            
            
            
             
            </Loader>
            
            </ActivityDetection>
            
            
            <ActivityDetection {...componentProps['header-state-loader-10'].csr.props}>
            
            
             
            <StateLoader { ...props} {...(componentProps['header-state-loader-10']?.props || {})}>
            
            <ActivityDetection {...componentProps['header-state-loader-10-children-page-loading-0'].csr.props}>
            
            
            <PageLoading { ...props} {...(componentProps['header-state-loader-10-children-page-loading-0']?.props || {})}/>
            
            </ActivityDetection>
            
             
            </StateLoader>
            
            </ActivityDetection>
            
            
            
            
            
            <EventPageViewDispatcher { ...props} {...(componentProps['header-event-page-view-dispatcher-11']?.props || {})}/>
            
            
            
          </header>
          <section { ...{"style":{"gridArea":"content"}} }>
            
            
            
            
            <AdsResolver { ...props} {...(componentProps['content-ads-resolver-0']?.props || {})}/>
            
            
            
            
            
            
            
            <ZipCodeBar { ...props} {...(componentProps['content-zip-code-bar-1']?.props || {})}/>
            
            
            
            
            
            
            
            <ZipCodeModal { ...props} {...(componentProps['content-zip-code-modal-2']?.props || {})}/>
            
            
            
            <LazyLoading {...componentProps['content-showcase-3'].csr.props}>
            
            
            
            <Showcase { ...props} {...(componentProps['content-showcase-3']?.props || {})}/>
            
            
            </LazyLoading>
            
            
            
            
             
            <Row { ...props} {...(componentProps['content-row-4']?.props || {})}>
            
            
            
            
            <MediaGallery { ...props} {...(componentProps['content-row-4-children-media-gallery-0']?.props || {})}/>
            
            
            
             
            
            
            
            
             
            <Row { ...props} {...(componentProps['content-row-4-children-row-1']?.props || {})}>
            {shouldRender(componentProps['content-row-4-children-row-1-children-seller-chat-button-0']) &&
            
            
            
            
            <SellerChatButton { ...props} {...(componentProps['content-row-4-children-row-1-children-seller-chat-button-0']?.props || {})}/>
            
            
            
            }
             
            
            
            
            
            <SocialShare { ...props} {...(componentProps['content-row-4-children-row-1-children-social-share-1']?.props || {})}/>
            
            
            
             
            </Row>
            
            
            
             
            <LazyLoading {...componentProps['content-row-4-children-row-2'].csr.props}>
            
            
            
             
            <Row { ...props} {...(componentProps['content-row-4-children-row-2']?.props || {})}>
            
            
            
            
            <FavoriteButton { ...props} {...(componentProps['content-row-4-children-row-2-children-favorite-button-0']?.props || {})}/>
            
            
            
             
            </Row>
            
            
            </LazyLoading>
             
            </Row>
            
            
            
            
            
            
            
             
            <Row { ...props} {...(componentProps['content-row-5']?.props || {})}>
            
            
            
            
             
            <Row { ...props} {...(componentProps['content-row-5-children-row-0']?.props || {})}>
            
            
            
            
            <ClosenessTag { ...props} {...(componentProps['content-row-5-children-row-0-children-closeness-tag-0']?.props || {})}/>
            
            
            
             
            
            
            
            
            <Rating { ...props} {...(componentProps['content-row-5-children-row-0-children-rating-1']?.props || {})}/>
            
            
            
             
            </Row>
            
            
            
             
            
            
            
            
            <Heading { ...props} {...(componentProps['content-row-5-children-heading-1']?.props || {})}/>
            
            
            
             
            
            
            
            
            <AlertAttributeMessage { ...props} {...(componentProps['content-row-5-children-alert-attribute-message-2']?.props || {})}/>
            
            
            
             
            
            
            
            
            <AttributeSelector { ...props} {...(componentProps['content-row-5-children-attribute-selector-3']?.props || {})}/>
            
            
            
             
            {shouldRender(componentProps['content-row-5-children-offer-timer-tag-4']) &&
            
            
            
            
            <OfferTimerTag { ...props} {...(componentProps['content-row-5-children-offer-timer-tag-4']?.props || {})}/>
            
            
            
            }
             
            
            
            
            
            <SellAndDeliverInfo { ...props} {...(componentProps['content-row-5-children-sell-and-deliver-info-5']?.props || {})}/>
            
            
            
             
            
            
            
            
             
            <SellerDetail { ...props} {...(componentProps['content-row-5-children-seller-detail-6']?.props || {})}>
            <LazyLoading {...componentProps['content-row-5-children-seller-detail-6-children-showcase-0'].csr.props}>
            
            
            
            <Showcase { ...props} {...(componentProps['content-row-5-children-seller-detail-6-children-showcase-0']?.props || {})}/>
            
            
            </LazyLoading>
             
            <LazyLoading {...componentProps['content-row-5-children-seller-detail-6-children-showcase-1'].csr.props}>
            
            
            
            <Showcase { ...props} {...(componentProps['content-row-5-children-seller-detail-6-children-showcase-1']?.props || {})}/>
            
            
            </LazyLoading>
             
            <LazyLoading {...componentProps['content-row-5-children-seller-detail-6-children-showcase-2'].csr.props}>
            
            
            
            <Showcase { ...props} {...(componentProps['content-row-5-children-seller-detail-6-children-showcase-2']?.props || {})}/>
            
            
            </LazyLoading>
             
            <LazyLoading {...componentProps['content-row-5-children-seller-detail-6-children-showcase-3'].csr.props}>
            
            
            
            <Showcase { ...props} {...(componentProps['content-row-5-children-seller-detail-6-children-showcase-3']?.props || {})}/>
            
            
            </LazyLoading>
             
            <LazyLoading {...componentProps['content-row-5-children-seller-detail-6-children-showcase-4'].csr.props}>
            
            
            
            <Showcase { ...props} {...(componentProps['content-row-5-children-seller-detail-6-children-showcase-4']?.props || {})}/>
            
            
            </LazyLoading>
             
            </SellerDetail>
            
            
            
             
            </Row>
            
            
            
            {shouldRender(componentProps['content-trade-in-6']) &&
            <LazyLoading {...componentProps['content-trade-in-6'].csr.props}>
            
            
            
            <TradeIn { ...props} {...(componentProps['content-trade-in-6']?.props || {})}/>
            
            
            </LazyLoading>
            }
            {shouldRender(componentProps['content-row-7']) &&
            <LazyLoading {...componentProps['content-row-7'].csr.props}>
            
            
            
             
            <Row { ...props} {...(componentProps['content-row-7']?.props || {})}>
            
            
            
            
            <ProductPrice { ...props} {...(componentProps['content-row-7-children-product-price-0']?.props || {})}/>
            
            
            
             
            
            
            
            
            <ProductTags { ...props} {...(componentProps['content-row-7-children-product-tags-1']?.props || {})}/>
            
            
            
             
            {shouldRender(componentProps['content-row-7-children-import-taxes-2']) &&
            <LazyLoading {...componentProps['content-row-7-children-import-taxes-2'].csr.props}>
            
            
            
            <ImportTaxes { ...props} {...(componentProps['content-row-7-children-import-taxes-2']?.props || {})}/>
            
            
            </LazyLoading>
            }
             
            {shouldRender(componentProps['content-row-7-children-coupon-code-3']) &&
            
            
            
            
            <CouponCode { ...props} {...(componentProps['content-row-7-children-coupon-code-3']?.props || {})}/>
            
            
            
            }
             
            <LazyLoading {...componentProps['content-row-7-children-cdccard-rave-4'].csr.props}>
            
            
            
            <CDCCardRave { ...props} {...(componentProps['content-row-7-children-cdccard-rave-4']?.props || {})}/>
            
            
            </LazyLoading>
             
            {shouldRender(componentProps['content-row-7-children-payment-method-cards-5']) &&
            
            
            
            
            <PaymentMethodCards { ...props} {...(componentProps['content-row-7-children-payment-method-cards-5']?.props || {})}/>
            
            
            
            }
             
            {shouldRender(componentProps['content-row-7-children-tab-installments-6']) &&
            
            
            
            
            <TabInstallments { ...props} {...(componentProps['content-row-7-children-tab-installments-6']?.props || {})}/>
            
            
            
            }
             
            </Row>
            
            
            </LazyLoading>
            }
            {shouldRender(componentProps['content-trade-in-8']) &&
            <LazyLoading {...componentProps['content-trade-in-8'].csr.props}>
            
            
            
            <TradeIn { ...props} {...(componentProps['content-trade-in-8']?.props || {})}/>
            
            
            </LazyLoading>
            }
            {shouldRender(componentProps['content-row-9']) &&
            <LazyLoading {...componentProps['content-row-9'].csr.props}>
            
            
            
             
            <Row { ...props} {...(componentProps['content-row-9']?.props || {})}>
            {shouldRender(componentProps['content-row-9-children-shipping-0']) &&
            <LazyLoading {...componentProps['content-row-9-children-shipping-0'].csr.props}>
            
            
            
            <Shipping { ...props} {...(componentProps['content-row-9-children-shipping-0']?.props || {})}/>
            
            
            </LazyLoading>
            }
             
            {shouldRender(componentProps['content-row-9-children-let-me-know-1']) &&
            
            
            
            
            <LetMeKnow { ...props} {...(componentProps['content-row-9-children-let-me-know-1']?.props || {})}/>
            
            
            
            }
             
            </Row>
            
            
            </LazyLoading>
            }
            {shouldRender(componentProps['content-row-10']) &&
            
            
            
            
             
            <Row { ...props} {...(componentProps['content-row-10']?.props || {})}>
            
            
            
            
            <ServicesBuyButton { ...props} {...(componentProps['content-row-10-children-services-buy-button-0']?.props || {})}/>
            
            
            
             
            </Row>
            
            
            
            }
            {shouldRender(componentProps['content-row-11']) &&
            <LazyLoading {...componentProps['content-row-11'].csr.props}>
            
            
            
             
            <Row { ...props} {...(componentProps['content-row-11']?.props || {})}>
            
            
            
            
            <BuyButtons { ...props} {...(componentProps['content-row-11-children-buy-buttons-0']?.props || {})}/>
            
            
            
             
            
            
            
            
            <AlertList { ...props} {...(componentProps['content-row-11-children-alert-list-1']?.props || {})}/>
            
            
            
             
            </Row>
            
            
            </LazyLoading>
            }
            {shouldRender(componentProps['content-row-12']) &&
            <LazyLoading {...componentProps['content-row-12'].csr.props}>
            
            
            
             
            <Row { ...props} {...(componentProps['content-row-12']?.props || {})}>
            
            
            
            
            <Heading { ...props} {...(componentProps['content-row-12-children-heading-0']?.props || {})}/>
            
            
            
             
            
            
            
            
            <BuyBox { ...props} {...(componentProps['content-row-12-children-buy-box-1']?.props || {})}/>
            
            
            
             
            
            
            
            
             
            <Row { ...props} {...(componentProps['content-row-12-children-row-2']?.props || {})}>
            
            
            
            
            <Button { ...props} {...(componentProps['content-row-12-children-row-2-children-button-0']?.props || {})}/>
            
            
            
             
            </Row>
            
            
            
             
            </Row>
            
            
            </LazyLoading>
            }
            
            
            
            
            <SummaryFactsheet { ...props} {...(componentProps['content-summary-factsheet-13']?.props || {})}/>
            
            
            
            <LazyLoading {...componentProps['content-row-14'].csr.props}>
            
            
            
             
            <Row { ...props} {...(componentProps['content-row-14']?.props || {})}>
            
            
            
            
            <TabProductDetail { ...props} {...(componentProps['content-row-14-children-tab-product-detail-0']?.props || {})}/>
            
            
            
             
            </Row>
            
            
            </LazyLoading>
            
            
            
            
            <ReviewSummary { ...props} {...(componentProps['content-review-summary-15']?.props || {})}/>
            
            
            
            {shouldRender(componentProps['content-row-16']) &&
            <LazyLoading {...componentProps['content-row-16'].csr.props}>
            
            
            
             
            <Row { ...props} {...(componentProps['content-row-16']?.props || {})}>
            
            
            
            
            <SellerInfo { ...props} {...(componentProps['content-row-16-children-seller-info-0']?.props || {})}/>
            
            
            
             
            </Row>
            
            
            </LazyLoading>
            }
            <LazyLoading {...componentProps['content-showcase-17'].csr.props}>
            
            
            
            <Showcase { ...props} {...(componentProps['content-showcase-17']?.props || {})}/>
            
            
            </LazyLoading>
            
            
            
            
             
            <Row { ...props} {...(componentProps['content-row-18']?.props || {})}>
            
            
            
            
            <Benefits { ...props} {...(componentProps['content-row-18-children-benefits-0']?.props || {})}/>
            
            
            
             
            {shouldRender(componentProps['content-row-18-children-report-button-1']) &&
            
            
            
            
            <ReportButton { ...props} {...(componentProps['content-row-18-children-report-button-1']?.props || {})}/>
            
            
            
            }
             
            </Row>
            
            
            
            <LazyLoading {...componentProps['content-ads-showcase-19'].csr.props}>
            
            
            
            <AdsShowcase { ...props} {...(componentProps['content-ads-showcase-19']?.props || {})}/>
            
            
            </LazyLoading>
            
            
            
            
             
            <Row { ...props} {...(componentProps['content-row-20']?.props || {})}>
            <LazyLoading {...componentProps['content-row-20-children-ads-banner-0'].csr.props}>
            
            
            
            <AdsBanner { ...props} {...(componentProps['content-row-20-children-ads-banner-0']?.props || {})}/>
            
            
            </LazyLoading>
             
            </Row>
            
            
            
            <LazyLoading {...componentProps['content-showcase-21'].csr.props}>
            
            
            
            <Showcase { ...props} {...(componentProps['content-showcase-21']?.props || {})}/>
            
            
            </LazyLoading>
            
            
            
            
             
            <Row { ...props} {...(componentProps['content-row-22']?.props || {})}>
            {shouldRender(componentProps['content-row-22-children-empty-review-button-0']) &&
            
            
            
            
            <EmptyReviewButton { ...props} {...(componentProps['content-row-22-children-empty-review-button-0']?.props || {})}/>
            
            
            
            }
             
            {shouldRender(componentProps['content-row-22-children-row-1']) &&
            
            
            
            
             
            <Row { ...props} {...(componentProps['content-row-22-children-row-1']?.props || {})}>
            
            
            
            
            <Heading { ...props} {...(componentProps['content-row-22-children-row-1-children-heading-0']?.props || {})}/>
            
            
            
             
            
            
            
            
            <ReviewStats { ...props} {...(componentProps['content-row-22-children-row-1-children-review-stats-1']?.props || {})}/>
            
            
            
             
            {shouldRender(componentProps['content-row-22-children-row-1-children-product-review-media-carousel-2']) &&
            
            
            
            
            <ProductReviewMediaCarousel { ...props} {...(componentProps['content-row-22-children-row-1-children-product-review-media-carousel-2']?.props || {})}/>
            
            
            
            }
             
            
            
            
            
            <ReviewListing { ...props} {...(componentProps['content-row-22-children-row-1-children-review-listing-3']?.props || {})}/>
            
            
            
             
            </Row>
            
            
            
            }
             
            {shouldRender(componentProps['content-row-22-children-row-2']) &&
            
            
            
            
             
            <Row { ...props} {...(componentProps['content-row-22-children-row-2']?.props || {})}>
            
            
            
            
            <ReviewSeeMore { ...props} {...(componentProps['content-row-22-children-row-2-children-review-see-more-0']?.props || {})}/>
            
            
            
             
            </Row>
            
            
            
            }
             
            </Row>
            
            
            
            <LazyLoading {...componentProps['content-showcase-23'].csr.props}>
            
            
            
            <Showcase { ...props} {...(componentProps['content-showcase-23']?.props || {})}/>
            
            
            </LazyLoading>
            {shouldRender(componentProps['content-row-24']) &&
            <LazyLoading {...componentProps['content-row-24'].csr.props}>
            
            
            
             
            <Row { ...props} {...(componentProps['content-row-24']?.props || {})}>
            
            
            
            
            <QuestionsList { ...props} {...(componentProps['content-row-24-children-questions-list-0']?.props || {})}/>
            
            
            
             
            
            
            
            
            <QuestionForm { ...props} {...(componentProps['content-row-24-children-question-form-1']?.props || {})}/>
            
            
            
             
            <LazyLoading {...componentProps['content-row-24-children-question-confirm-2'].csr.props}>
            
            
            
            <QuestionConfirm { ...props} {...(componentProps['content-row-24-children-question-confirm-2']?.props || {})}/>
            
            
            </LazyLoading>
             
            <LazyLoading {...componentProps['content-row-24-children-question-feedback-3'].csr.props}>
            
            
            
            <QuestionFeedback { ...props} {...(componentProps['content-row-24-children-question-feedback-3']?.props || {})}/>
            
            
            </LazyLoading>
             
            <LazyLoading {...componentProps['content-row-24-children-divider-4'].csr.props}>
            
            
            
             
            <Divider { ...props} {...(componentProps['content-row-24-children-divider-4']?.props || {})}>
            {shouldRender(componentProps['content-row-24-children-divider-4-children-question-see-more-0']) &&
            
            
            
            
            <QuestionSeeMore { ...props} {...(componentProps['content-row-24-children-divider-4-children-question-see-more-0']?.props || {})}/>
            
            
            
            }
             
            </Divider>
            
            
            </LazyLoading>
             
            </Row>
            
            
            </LazyLoading>
            }
            <LazyLoading {...componentProps['content-showcase-25'].csr.props}>
            
            
            
            <Showcase { ...props} {...(componentProps['content-showcase-25']?.props || {})}/>
            
            
            </LazyLoading>
            {shouldRender(componentProps['content-row-26']) &&
            <LazyLoading {...componentProps['content-row-26'].csr.props}>
            
            
            
             
            <Row { ...props} {...(componentProps['content-row-26']?.props || {})}>
            {shouldRender(componentProps['content-row-26-children-faq-0']) &&
            
            
            
            
            <Faq { ...props} {...(componentProps['content-row-26-children-faq-0']?.props || {})}/>
            
            
            
            }
             
            </Row>
            
            
            </LazyLoading>
            }
          </section>
          <footer { ...{"style":{"gridArea":"footer"}} }>
            
            
            
            
            <VersionTag { ...props} {...(componentProps['footer-version-tag-0']?.props || {})}/>
            
            
            
            
            <ActivityDetection {...componentProps['footer-back-to-top-1'].csr.props}>
            
            
            <BackToTop { ...props} {...(componentProps['footer-back-to-top-1']?.props || {})}/>
            
            </ActivityDetection>
            
          </footer>
      </div>
    </>
  )
};

let clientProps = {};
clientProps.manifest = manifest;
clientProps.appConfig = raveConfig || {};
clientProps.route = {
  id: routeInfo.id,
  name: routeInfo.name,
  pathPattern: routeInfo.pathPattern,
  pathAliases: routeInfo.pathAliases,
  renderMethod: routeInfo.renderMethod
};
clientProps.isServerRequest = false;
clientProps.componentsList = componentsList;

  const clientSideBeforeFetchMiddlewares = [
    { id: 'getAppTheme', functionMiddleware: getAppTheme },
    { id: 'getUserInfo', functionMiddleware: getUserInfo },
    { id: 'getVersions', functionMiddleware: getVersions },
    { id: 'writePromoterIdCookie', functionMiddleware: writePromoterIdCookie },
  ];

  const clientSideAfterFetchMiddlewares = [
    { id: 'setPromoterCartExtensions', functionMiddleware: setPromoterCartExtensions },
    { id: 'parseAdsData', functionMiddleware: parseAdsData },
    { id: 'itemAttributeMapper', functionMiddleware: itemAttributeMapper },
    { id: 'highestInstallmentPlanAsBest', functionMiddleware: highestInstallmentPlanAsBest },
    { id: 'getProductAlerts', functionMiddleware: getProductAlerts },
    { id: 'getCouponTag', functionMiddleware: getCouponTag },
  ];

export default withRouter(
  withClientData(
    withEventsLayer(
      Container,
      {
        routeInfo,
        events: events(),
        eventsCustomConfig: eventsConfig,
        dataStoreSetupKey: "userInfo",
        clientProps,
      }
    ),
    {
    pageQuery: PageQuery,
    getPageVariables,
    middlewares: {
      clientProps,
      clientSideBeforeFetchMiddlewares,
      clientSideAfterFetchMiddlewares,
      middlewaresArgs,
    },
  }),
  { ...routeInfo, manifest },
  false,
  routes
);

